/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Add_Fixed_RateInputs */

const en_admin_resource_form_add_fixed_rate = /** @type {(inputs: Admin_Resource_Form_Add_Fixed_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add fixed rate`)
};

const de_admin_resource_form_add_fixed_rate = /** @type {(inputs: Admin_Resource_Form_Add_Fixed_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Festpreis hinzufügen`)
};

const es_admin_resource_form_add_fixed_rate = /** @type {(inputs: Admin_Resource_Form_Add_Fixed_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir precio fijo`)
};

const fr_admin_resource_form_add_fixed_rate = /** @type {(inputs: Admin_Resource_Form_Add_Fixed_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un prix fixe`)
};

const nl_admin_resource_form_add_fixed_rate = /** @type {(inputs: Admin_Resource_Form_Add_Fixed_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vast tarief toevoegen`)
};

/** @type {(inputs: Admin_Resource_Form_Add_Fixed_RateInputs) => LocalizedString} */
const it_admin_resource_form_add_fixed_rate = en_admin_resource_form_add_fixed_rate;

/** @type {(inputs: Admin_Resource_Form_Add_Fixed_RateInputs) => LocalizedString} */
const pt_br2_admin_resource_form_add_fixed_rate = en_admin_resource_form_add_fixed_rate;

/** @type {(inputs: Admin_Resource_Form_Add_Fixed_RateInputs) => LocalizedString} */
const pl_admin_resource_form_add_fixed_rate = en_admin_resource_form_add_fixed_rate;

/** @type {(inputs: Admin_Resource_Form_Add_Fixed_RateInputs) => LocalizedString} */
const hu_admin_resource_form_add_fixed_rate = en_admin_resource_form_add_fixed_rate;

/** @type {(inputs: Admin_Resource_Form_Add_Fixed_RateInputs) => LocalizedString} */
const ro_admin_resource_form_add_fixed_rate = en_admin_resource_form_add_fixed_rate;

/**
* | output |
* | --- |
* | "Add fixed rate" |
*
* @param {Admin_Resource_Form_Add_Fixed_RateInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_add_fixed_rate = /** @type {((inputs?: Admin_Resource_Form_Add_Fixed_RateInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Add_Fixed_RateInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_add_fixed_rate(inputs)
	if (locale === "de") return de_admin_resource_form_add_fixed_rate(inputs)
	if (locale === "es") return es_admin_resource_form_add_fixed_rate(inputs)
	if (locale === "fr") return fr_admin_resource_form_add_fixed_rate(inputs)
	if (locale === "nl") return nl_admin_resource_form_add_fixed_rate(inputs)
	if (locale === "it") return it_admin_resource_form_add_fixed_rate(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_add_fixed_rate(inputs)
	if (locale === "pl") return pl_admin_resource_form_add_fixed_rate(inputs)
	if (locale === "hu") return hu_admin_resource_form_add_fixed_rate(inputs)
	return ro_admin_resource_form_add_fixed_rate(inputs)
});
export { admin_resource_form_add_fixed_rate as "admin.resource_form.add_fixed_rate" }